import { $t } from '@/utils/languageAuto';
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AddSubjectForm from '../addSubject/index.vue';
import { tc } from '@/utils/language';

var AddSubjectModal = function (_super) {
  __extends(AddSubjectModal, _super);

  function AddSubjectModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    return _this;
  }

  AddSubjectModal.prototype.handleSave = function () {
    var _this = this;

    var _a;

    var addSubjectFormRef = this.$refs.addSubjectFormRef;

    if (!!((_a = this.data.sign_body_info) === null || _a === void 0 ? void 0 : _a.account_code)) {
      addSubjectFormRef === null || addSubjectFormRef === void 0 ? void 0 : addSubjectFormRef.submit(function () {
        _this.visible = false;

        _this.$message.success(_this.t('保存成功'));

        typeof _this.onSuccess === 'function' && _this.onSuccess();
      });
    } else {
      addSubjectFormRef === null || addSubjectFormRef === void 0 ? void 0 : addSubjectFormRef.addFirm(function () {
        _this.visible = false;

        _this.$message.success(_this.t('保存成功'));

        typeof _this.onSuccess === 'function' && _this.onSuccess();
      });
    }
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], AddSubjectModal.prototype, "data", void 0);

  __decorate([Prop({
    type: Function,
    "default": function _default() {
      return function () {};
    }
  })], AddSubjectModal.prototype, "onSuccess", void 0);

  __decorate([Prop({
    type: String,
    "default": tc('添加主体信息')
  })], AddSubjectModal.prototype, "title", void 0);

  AddSubjectModal = __decorate([Component({
    components: {
      AddSubjectForm: AddSubjectForm
    }
  })], AddSubjectModal);
  return AddSubjectModal;
}(Vue);

export default AddSubjectModal;